<div class="fondEcran" [ngClass]="{'connecte':(sessionUser != null)}"></div>
@if (sessionUser != null) {
<header>
    <!-- Sidebar navigation -->
    <nav class="navbar navbar-expand-lg navbar-dark fixed-top">
        <div class="container">
            <div class="navbar-collapse collapse show">
                <div class="logo click" (click)="clicLogo()">
                    <!-- Logo -->
                    <img src="/assets/img/icon-white.png" alt="">
                    @if (sessionUser) {
                    <div>{{sessionUser.LOGIN}}</div>
                    }
                </div>
                <links class="lk1">
                    <!-- Side navigation links -->
                    <ul class="nav navbar-nav nav-flex-icons ie-double-nav">
                        <!-- Retour -->
                        <li class="nav-item">
                            @if (fRetour) {
                            <a class="nav-link" (click)="fRetour()">
                                <i class="fa fa-arrow-left"></i>
                            </a>
                            }
                        </li>
                        @for (o of menuItems; track o; let i = $index) {
                        <menu-gala [item]="o" (opened)="menuOuvert(i)" />
                        }
                    </ul>
                </links>
                @if (fRechercher) {
                <links class="flex-fill lk2">
                    <ul class="nav navbar-nav nav-flex-icons ie-double-nav flex-fill">
                        <!--Search Form-->
                        <li class="flex-fill">
                            <form class="search-form" role="search" novalidate>
                                <div class="form-group md-form">
                                    <input type="text" class="form-control"
                                        [placeholder]="translate.instant('RECHERCHE')" [(ngModel)]="valRecherche"
                                        [ngModelOptions]="{standalone: true}" (ngModelChange)="fRechercher($event)">
                                    @if (valRecherche.length > 0) {
                                    <input type="reset" class="close-icon" (click)="emptySearchInput()" value="x" />
                                    }
                                </div>
                            </form>
                        </li>
                    </ul>
                </links>
                }
                <links class="lk3">
                    <ul class="end nav navbar-nav nav-flex-icons ie-double-nav">
                        @if (personneIncarnee) {
                        <li class="nav-item mr-3">
                            <span class="zone-superviseur">
                                <button type="button" class="badge badge-warning border-0 cursor-hand"
                                    (click)="bulleSuperviseurOuverte = !bulleSuperviseurOuverte">{{translate.instant("INCARNATION.MODESUPERVISEUR")}}</button>
                                @if (bulleSuperviseurOuverte) {
                                <div class="bulle-superviseur">
                                    <div class="mb-3">{{translate.instant("INCARNATION.CONNECTEENTANTQUE")}}<br><strong>{{personneIncarnee}}</strong></div>
                                    <button mat-stroked-button color="primary" type="button"
                                        (click)="revenirAMonCompte()">{{translate.instant("INCARNATION.REVENIR")}}</button>
                                </div>
                                }
                            </span>
                        </li>
                        }
                        @if (fCreer) {
                        <menu-gala [item]="menuCreer" (click)="fCreer();closeAllMenu()" />
                        }
                        @if (fUpload) {
                        <menu-gala [item]="menuUpload" (click)="clicUpload();closeAllMenu()" />
                        }
                        @if (fExporter) {
                        <menu-gala [item]="menuExporter" (click)="fExporter();closeAllMenu()" />
                        }
                        <menu-gala [item]="menuExploitation" (click)="fExploitation();closeAllMenu()" />
                        <menu-gala [item]="menuMonCompte" (opened)="menuOuvert(menus.length-1)" />
                    </ul>
                </links>
            </div>
        </div>
    </nav>
    <!--/. Navbar -->
</header>
} @else {
<img src="./assets/img/logo-big.png" class="imgLogoConnexion" alt="">
}
<app-spinner />
<!--/.Double navigation-->
<!--Main Layout-->
<main>
    <h4 class="titrePage">
        {{titre}}
    </h4>

    <div class="container-fluid mt-5">
        <router-outlet (activate)="componentAdded($event)" />
    </div>
</main>
<!--/Main layout-->
<footer>
    <div class="liFooter">
        <div class="realisePar">
            {{translate.instant("MADEBY")}} &nbsp;<img src="/assets/img/estel_petit.png" alt="" />
        </div>
    </div>
</footer>